import React, { useEffect, useState } from "react";
import { fetchJobs } from "../api";
import HistoryDetail from "./HistoryDetail";

function formatDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString();
}

export default function HistoryList({ excludeJobId, refreshKey }) {
  const [summaries, setSummaries] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expandedJobId, setExpandedJobId] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchJobs()
      .then((body) => {
        if (cancelled) return;
        const jobs = (body.jobs || []).filter((j) => j.job_id !== excludeJobId);
        setSummaries(jobs);
        setLoading(false);
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e.message || String(e));
        setLoading(false);
      });
    return () => { cancelled = true; };
  }, [excludeJobId, refreshKey]);

  if (loading) return <div className="bfr-history">Loading history…</div>;
  if (error) return <div className="bfr-history">Could not load history: {error}</div>;
  if (summaries.length === 0) return null;

  return (
    <div className="bfr-history">
      <h2>Past runs</h2>
      {summaries.map((j) => {
        const p = j.progress || {};
        const periodText = j.period ? `${j.period.month_name} ${j.period.year}` : "—";
        const expanded = expandedJobId === j.job_id;
        return (
          <React.Fragment key={j.job_id}>
            <div className="bfr-history-row">
              <div className="bfr-history-summary">
                {formatDate(j.started_at)} — {j.started_by_user || "—"} — {periodText} —{" "}
                <span className={`bfr-history-status ${j.status}`}>{j.status}</span> ·{" "}
                ✓ {p.succeeded || 0} / ⊘ {p.skipped || 0} / ✗ {p.failed || 0}
              </div>
              <div className="bfr-history-actions">
                <button onClick={() => setExpandedJobId(expanded ? null : j.job_id)}>
                  {expanded ? "Hide" : "View"}
                </button>
              </div>
            </div>
            {expanded && <HistoryDetail jobId={j.job_id} />}
          </React.Fragment>
        );
      })}
    </div>
  );
}
